import { Icon, Text } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { CoverageSuggestion } from "../types";
import { coverageSuggestionIconMap } from "./iconMap";

interface CoverageSuggestionCardProps {
  suggestion: CoverageSuggestion;
}

export const CoverageSuggestionCard = ({
  suggestion,
}: CoverageSuggestionCardProps) => {
  const { name, icon, description } = suggestion;
  const iconDefinition = coverageSuggestionIconMap[icon];

  const classes = classNames("mobius", "mobius-coverage-suggestion-card");

  return (
    <div className={classes} data-testid="coverage-suggestion-card">
      <div className="mobius-coverage-suggestion-card__header">
        {iconDefinition && (
          <Icon
            icon={iconDefinition}
            size="md"
            className="mobius-coverage-suggestion-card__icon"
            aria-hidden="true"
          />
        )}
        <Text
          elementType="h3"
          variant="h4"
          className="mobius-coverage-suggestion-card__title"
        >
          {name}
        </Text>
      </div>
      <Text className="mobius-coverage-suggestion-card__description">
        {description}
      </Text>
    </div>
  );
};

CoverageSuggestionCard.displayName = "CoverageSuggestionCard";
